import { useState, useMemo } from 'react'
import { Moment } from 'moment'
import {
  ArrowButton,
  Card,
  Button,
  Popover,
  DatePicker,
  Icon,
} from 'components/common'
import { LedgerSingleItem, LedgerSingleItemTable } from '../tables'
import { Link } from 'gatsby'
import { routes } from 'config'

interface LedgerUrlState {
  id: string
  month: string
  title: string
}

export interface LedgerSingleItemCardProps {
  dataSource: LedgerSingleItem[]
  date: Moment
  handleViewDay: (day: Moment) => void
  urlState: LedgerUrlState
  loading: boolean
}

export const LedgerSingleItemCard = ({
  date,
  dataSource,
  handleViewDay,
  urlState,
  loading,
}: LedgerSingleItemCardProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const handleDateChange = (date: Moment, dateString: string) => {
    handleViewDay(date)
    setIsVisible(false)
  }

  const handleUpDownMonth = (step: boolean) => {
    if (step) {
      handleViewDay(date?.add(1, 'month').clone())
    } else {
      handleViewDay(date?.subtract(1, 'month').clone())
    }
  }
  const buttonCover = useMemo((): JSX.Element => {
    return (
      <div className="space-x-2">
        <Icon.CalendarTwoTone />
        <span>{date?.format('YYYY年MM月')}</span>
      </div>
    )
  }, [date])
  return (
    <>
      <Card
        loading={loading}
        title={
          <div className="flex">
            <Button.Group>
              <ArrowButton
                direction="left"
                onClick={() => handleUpDownMonth(false)}
              />

              <Popover
                title={'月を選択'}
                visible={isVisible}
                onVisibleChange={setIsVisible}
                trigger="click"
                content={
                  <DatePicker
                    allowClear={false}
                    picker="month"
                    value={date}
                    onChange={handleDateChange}
                  />
                }
              >
                <Button onClick={() => setIsVisible(!isVisible)}>
                  {buttonCover}
                </Button>
              </Popover>

              <ArrowButton
                direction="right"
                onClick={() => handleUpDownMonth(true)}
              />
            </Button.Group>
          </div>
        }
        extra={
          <Button type="link">
            <Link to={routes.ledgers} state={{ ...urlState }}>
              編集する
            </Link>
          </Button>
        }
      >
        <LedgerSingleItemTable dataSource={dataSource} loading={loading} />
      </Card>
    </>
  )
}
